import { canUseModule, type ModuleLite, type RoleLite } from '@blauturquesa/shared/roles-lite';
import type { IconName } from '../components/Icon';

export interface TabDef {
  id: string;
  path: string;
  icon: IconName;
  /** Clau i18n (namespace shell). */
  label: string;
}

const T = {
  explora: { id: 'explora', path: '/explora', icon: 'compass', label: 'tabs.explore' },
  mapa: { id: 'mapa', path: '/mapa', icon: 'map', label: 'tabs.map' },
  entrar: { id: 'entrar', path: '/entrar', icon: 'login', label: 'tabs.signIn' },
  missatges: { id: 'missatges', path: '/missatges', icon: 'message', label: 'tabs.messages' },
  reserves: { id: 'reserves', path: '/reserves', icon: 'calendarCheck', label: 'tabs.bookings' },
  compte: { id: 'compte', path: '/compte', icon: 'user', label: 'tabs.account' },
  avui: { id: 'avui', path: '/avui', icon: 'sun', label: 'tabs.today' },
  propietats: { id: 'propietats', path: '/propietats', icon: 'home', label: 'tabs.properties' },
  calendari: { id: 'calendari', path: '/calendari', icon: 'calendar', label: 'tabs.calendar' },
  mes: { id: 'mes', path: '/mes', icon: 'dots', label: 'tabs.more' },
  oportunitats: { id: 'oportunitats', path: '/oportunitats', icon: 'swap', label: 'tabs.opportunities' },
} as const satisfies Record<string, TabDef>;

/**
 * Pestanyes segons el perfil actiu (§10.4). `null` = visitant sense sessió. Màxim 5.
 * Gestió: amb el mòdul d'oportunitats, aquest ocupa el cinquè lloc i el que hi havia a «Més» passa
 * al full de l'avatar (decisió de l'usuari, 2026-10-30); sense el mòdul, es manté «Més».
 */
export function tabsFor(activeRole: RoleLite | null, signedIn: boolean, modules: readonly ModuleLite[] = []): TabDef[] {
  if (!signedIn) return [T.explora, T.mapa, T.entrar];
  if (activeRole === 'agent' || activeRole === 'superadmin') {
    return [T.avui, T.propietats, T.calendari, T.missatges, canUseModule(activeRole, modules, 'opportunities') ? T.oportunitats : T.mes];
  }
  return [T.explora, T.mapa, T.missatges, T.reserves, T.compte];
}

/** La pestanya a què pertany una adreça (p. ex. /mes/usuaris → Més). */
export function tabForPath(tabs: readonly TabDef[], pathname: string): TabDef | undefined {
  return tabs.find((t) => pathname === t.path || pathname.startsWith(`${t.path}/`));
}
